import { ScreenerContext, withScreenerMachineState } from 'domains/signup/screener/context/screenerContext';
import { Paragraph, Button, Heading, TwoPanelsPageLayout } from '@expressable/syntax-ds';
import { useTranslation } from 'react-i18next';
import resultsPreviewImg from 'assets/images/screener/landingpage-results-preview.webp';

const LandingPage = () => {
  const { t } = useTranslation();
  const { send } = ScreenerContext.useActorRef();

  const handleStartScreener = () => {
    send({ type: 'startScreener' });
  };

  return (
    <TwoPanelsPageLayout>
      <TwoPanelsPageLayout.LeftPanel className="p-0 px-24 gap-0 tablet-d:gap-0 justify-start">
        <Heading level="h2">{t('screener.landingPage.title')}</Heading>
        <Paragraph>{t('screener.landingPage.description')}</Paragraph>
        <Paragraph>
          <span className="font-semibold">1. {t('screener.landingPage.bullets.1.title')}</span>{' '}
          {t('screener.landingPage.bullets.1.description')}
        </Paragraph>
        <Paragraph>
          <span className="font-semibold">2. {t('screener.landingPage.bullets.2.title')}</span>{' '}
          {t('screener.landingPage.bullets.2.description')}
        </Paragraph>
        <Paragraph>
          <span className="font-semibold">3. {t('screener.landingPage.bullets.3.title')}</span>{' '}
          {t('screener.landingPage.bullets.3.description')}
        </Paragraph>
        <Button className="hidden md:flex mt-4" onClick={handleStartScreener}>
          {t('screener.landingPage.startButton')}
        </Button>
      </TwoPanelsPageLayout.LeftPanel>
      <TwoPanelsPageLayout.RightPanel className="p-0 tablet-d:p-24 justify-start h-min">
        <img
          alt="Sample speech therapy screener results page showing a progress chart, scores, and recommendations"
          srcSet={resultsPreviewImg}
          className="max-w-full h-auto"
        />
        <Button className="md:hidden mt-8" onClick={handleStartScreener}>
          {t('screener.landingPage.startButton')}
        </Button>
      </TwoPanelsPageLayout.RightPanel>
    </TwoPanelsPageLayout>
  );
};

export const ScreenerLandingPage = withScreenerMachineState(LandingPage, 'landingPage');
